import React, { Component } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { EventFormStore } from 'stores/events/event-form-store';
import { IdentityService } from 'services/identity-service';
import { resolve } from 'inversify-react';
import { hasAdministrationRights, hasInstructorRights, isPocOrFactoryLeadInExtendedWf } from 'utils/event-utils';
import HaveWarningsPopup from 'site/pages/events/event-form/popups/have-warnings-popup/have-warnings-popup'; // ajusta la ruta
interface Props extends WithTranslation {
  eventFormStore: EventFormStore;
  readOnly: boolean;
  onEdit?: (edit: 'edit') => void;
  onSave?: (save: 'save') => void;
}

interface State {
  showHaveWarningsModal: boolean;
  saving: boolean;
}

class EventEditButtonTw extends Component<Props, State> {
  @resolve(IdentityService)
  private identityService!: IdentityService;

  state: State = {
    showHaveWarningsModal: false,
    saving: false
  };

  handleOnAcceptedWarnings = () => {
    this.saveEvent();
    this.setState({ showHaveWarningsModal: false });
  };

  handleOnSaveClick = () => {
    const event = this.props.eventFormStore.state.item;
    if (event.warningMessages.length > 0 && (event.status.toString() === 'Draft' || event.status.toString() === 'Planned')) {
      this.setState({ showHaveWarningsModal: true });
      return;
    }
    this.saveEvent();
  };

  saveEvent = async () => {
    this.props.onSave && this.props.onSave('save');
  };

  handleOnEditClick = () => {
    this.props.onEdit && this.props.onEdit('edit');
  };

  isVisible(): boolean {
    const event = this.props.eventFormStore.state.item;
    if (!event) return false;

    const userInfo = this.identityService.getUserInfo();
    if (IdentityService.isAdmin(userInfo)) return true;
    if (IdentityService.isReporting(userInfo)) return false;
    if (hasAdministrationRights(event) || hasInstructorRights(event) || isPocOrFactoryLeadInExtendedWf(event)) {
      return true;
    }
    return false;
  }

  renderEditButton() {
    const { t } = this.props;
    return (
      <button
        type="button"
        className="flex-1 py-2 rounded border border-gray-300 text-gray-700 font-semibold hover:bg-gray-100 transition-all text-sm"
        onClick={() => this.handleOnEditClick()}
        style={{ minWidth: 0 }}
      >
        <span className="flex items-center justify-center gap-1">
          {t('Edit')}
          <svg
            className="w-4 h-4 text-gray-800"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"
            />
          </svg>
        </span>
      </button>
    );
  }

  renderSaveButton() {
    const { t } = this.props;
    const { saving, showHaveWarningsModal } = this.state;

    return (
      <>
        <button
          type="button"
          className={`flex-1 py-2 rounded border border-gray-300 text-gray-700 font-semibold hover:bg-gray-100 transition-all text-sm ${
            saving ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100'
          }`}
          onClick={() => !saving && this.handleOnSaveClick()}
          style={{ minWidth: 0 }}
          disabled={saving}
        >
          {saving ? t('Saving...') : t('Save')}
        </button>

        <HaveWarningsPopup
          open={showHaveWarningsModal}
          onAcceptClicked={this.handleOnAcceptedWarnings}
          onCancelClicked={() => this.setState({ showHaveWarningsModal: false })}
        />
      </>
    );
  }

  render() {
    if (!this.isVisible()) return null;

    return this.props.readOnly ? this.renderEditButton() : this.renderSaveButton();
  }
}

export default withTranslation()(EventEditButtonTw);
